import React from 'react';

const SettingsHeader = ({ id, children }) => {
  return (
    <h2 className="text-lg leading-tight font-bold text-gray-900 flex items-start mb-2" id={id}>
      {children}
    </h2>
  );
};

export default SettingsHeader;
